import React from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import './index.scss';

const PageTopbar = ({ title, onBack, backLabel, disabled = false, actions, className = '' }) => <div className={`pageTopbar ${className}`}>
  <Button className="pageTopbar-back" type="text" icon={<LeftOutlined />} aria-label={backLabel} disabled={disabled} onClick={onBack}>返回</Button>
  <h2 className="pageTopbar-title" title={typeof title === 'string' ? title : undefined}>{title}</h2>
  <div className="pageTopbar-actions">{actions}</div>
</div>;

export default PageTopbar;
